import ZoomInMapIcon from '@mui/icons-material/ZoomInMap';
import L from 'leaflet';
import { useMap, ZoomControl } from 'react-leaflet';

import { ITileLayerInfo } from '../../layers';
import { useSettings } from '../../../../Settings/useSettings';
import { ToolbarFlowOrientation } from '../../../../Settings/settingsTypes';
import ButtonControl from './buttonControl';


type MapZoomControlsProps = {
    layerInfo: ITileLayerInfo
};


const MapZoomControls = (props: MapZoomControlsProps) => {

  const map = useMap();
  const settings = useSettings();

  const position: L.ControlPosition = settings.ui.toolbarFlowOrientation === ToolbarFlowOrientation.RightHanded ? "topright" : "topleft";

  const canZoomMax = !!props.layerInfo && map.getZoom() !== props.layerInfo.maxZoom;

  const handleZoomMax = () => {
    if (!canZoomMax)
      return;

    map.setZoom(props.layerInfo.maxZoom);
  };


  /**
   * Render
   */
  return (
    <>
      <ZoomControl position={position}/>

      <ButtonControl position={position} onClick={handleZoomMax} title="Zoom to maximum" disabled={!canZoomMax}>
        <ZoomInMapIcon fontSize="medium"/>
      </ButtonControl>
    </>
  )
}

export default MapZoomControls;